<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section row mr-0 ml-0 special-header header-title">
              <h1 class="form-title col-md-4 mr-0 pl-0">
                Confirm Eligibility for the “Self-Rated” Program
              </h1>
              <p class="col-md-4">
                To be eligible for the premium options shown below, the Responses to statements 1 through 10 must all be “True”.              </p>
              <img
                src="../../../public/assets/images/pillar.png"
                style="width: 234px;"
                class="title-section-img form-title-img risk-mgt-img col-md-4"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">1.</span>
                    The Applicant is a member of the California Association of REALTORS®.</label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfCaliforniaAssosiation"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfCaliforniaAssosiation"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfCaliforniaAssosiation"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfCaliforniaAssosiation"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('memberOfCaliforniaAssosiation')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('memberOfCaliforniaAssosiation') | filterText }}</span>
                  </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">2.</span>
                    No owner, agent or member of the Applicant company has had their license revoked, been investigated or
                    been subject to any disciplinary action by any licensing board, real estate association or other regulatory
                    body within the last 5 years.                      </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyRevokedLiceseLast5Years"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyRevokedLiceseLast5Years"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyRevokedLiceseLast5Years"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyRevokedLiceseLast5Years"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('companyRevokedLiceseLast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('companyRevokedLiceseLast5Years') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">3.</span>
                    No owner, agent or member of the Applicant company has been cancelled, refused insurance or declined
                    by an insurance carrier during the last 5 years (except due to loss of market or non payment of premium).                   </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyCancelledLast5Years"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyCancelledLast5Years"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyCancelledLast5Years"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyCancelledLast5Years"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('companyCancelledLast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('companyCancelledLast5Years') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">4.</span>
                    No owner, agent or member of the company is involved in business brokering, mortgage brokering,
                    appraisal services, property management, development or construction.   </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfCompanyInvolvedBrokering"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfCompanyInvolvedBrokering"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfCompanyInvolvedBrokering"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfCompanyInvolvedBrokering"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('memberOfCompanyInvolvedBrokering')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('memberOfCompanyInvolvedBrokering') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">5.</span>
                    No owner or agent of the company has an exclusive listing agreement with any builder/developer.             </label>
                </div>
                <div class="col-md-3 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyExclusiveListingAgreement"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyExclusiveListingAgreement"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="companyExclusiveListingAgreement"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.companyExclusiveListingAgreement"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('companyExclusiveListingAgreement')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('companyExclusiveListingAgreement') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                    <label for class="orep-label">
                      <span class="mr-2">6.</span>
                      The Applicant’s total gross revenues did not exceed $500,000 for the past 36 months. (gross revenues are defined as all fees and commissions before expenses payable to employees
                      and independent contractors)                </label>
                  </div>
                  <div class="col-md-4 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="last3YearsGrossRevenue"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="rxApplication.last3YearsGrossRevenue"
                          >
                          <span class="radio-span">True</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="last3YearsGrossRevenue"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="rxApplication.last3YearsGrossRevenue"
                          >
                          <span class="radio-span">False</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('last3YearsGrossRevenue')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('last3YearsGrossRevenue') | filterText }}</span>
                  </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">7.</span>
                    The Applicant and anyone to whom this insurance will apply is not aware of any professional liability claim
                    or any acts, errors, omission or Personal Injuries which might reasonably be expected to be the basis of a
                    claim made against them within the past 5 years. </label>                  </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('claimMadeInPast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimMadeInPast5Years') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">8.</span>
                    No owner, agent or member of the Applicant has provided services related to properties that included
                    involvement in any eviction procedures, delivering or negotiating cash for keys offers or property
                    rehabilitation.         </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfApplicantProvidedServices"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfApplicantProvidedServices"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="memberOfApplicantProvidedServices"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.memberOfApplicantProvidedServices"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('memberOfApplicantProvidedServices')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('memberOfApplicantProvidedServices') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">9.</span>
                    No more than 50% of the Applicant's transactions are dual agency.           </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantTransactionsDualAgency"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.applicantTransactionsDualAgency"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantTransactionsDualAgency"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.applicantTransactionsDualAgency"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantTransactionsDualAgency')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantTransactionsDualAgency') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-2">10.</span>
                    No more than 50% of the Applicant's transactions are from agent-owned property sales.           </label>
                </div>
                <div class="col-md-4 d-flex flex-column justify-content-center">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantTransactionsAgentOwnedPropertySales"
                          :value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.applicantTransactionsAgentOwnedPropertySales"
                        >
                        <span class="radio-span">True</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantTransactionsAgentOwnedPropertySales"
                          :value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rxApplication.applicantTransactionsAgentOwnedPropertySales"
                        >
                        <span class="radio-span">False</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantTransactionsAgentOwnedPropertySales')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantTransactionsAgentOwnedPropertySales') | filterText }}</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rx-application-1'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button @click="prev()" class="pagination-dots"></button>
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid"
                @click="navigateToNext('rx-application-3')">
              </button>
              <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
                @click="navigateToNext('rx-application-4')">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid|| !state.pageSixIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageTwoIsValid"
                    :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="next()">Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Calculating premium...</span>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "rx-application-2",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      rxApplication() {
        return this.$store.state.rxApplication.rxApplication;
      },
      state() {
        return this.$store.state.rxApplication;
      },
      errorMsg() {
        return this.$store.state.rxApplication.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              text: this.errorMsg,
              duration: 15000
            });
          }
        }
      }
    },
    methods: {
      prev() {
        this.$router.push({
          name: "rx-application-1"
        });
      },

      navigateToNext(routeName) {
        this.getPremium();
        this.$router.push({
          name: routeName,
        });

      },
      next() {
        var routeName = 'rx-application-3'
        if (this.rxApplication.companyRevokedLiceseLast5Years === false || this.rxApplication.companyCancelledLast5Years === false || this.rxApplication.memberOfCompanyInvolvedBrokering === false
          || this.rxApplication.companyExclusiveListingAgreement === false || this.rxApplication.last3YearsGrossRevenue === false || this.rxApplication.claimMadeInPast5Years === false
          || this.rxApplication.memberOfApplicantProvidedServices === false
          || this.rxApplication.memberOfCaliforniaAssosiation === false || this.rxApplication.applicantTransactionsDualAgency === false || this.rxApplication.applicantTransactionsAgentOwnedPropertySales === false){
          routeName = 'rx-application-standard-program'
        }
        else{

          this.getPremium();
        }

        this.$router.push({
          name: routeName,
        });

      },

      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageTwoIsValid = true;
            return;
          }
          this.state.pageTwoIsValid = false;
        });
      },

      getPremium() {
        this.loading = true;
        this.$store.dispatch('rxApplication/getPremium');
      }
    },

    mounted() {
      $("html, body").animate(
        {
          scrollTop: $(".page-content").offset().top
        },
        500
      );
    },

    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },
    components: {}
  };
</script>
